import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'
import {api} from './APIMiddlewares'

export async function setup(InputField: {
  name: string
  address: string
  country: string
  state: string
  city: string
  pincode: string
  website: string
  weekStartDay: string
  weekendDays: string[]
  financialYearStartDate: string
  financialYearEndDate: string
  firstName: string
  lastName: string
  email: string
  password: string
  mobile: string
  inTime: string
  outTime: string
}) {
  const res = await fetch(API_BASE_URL + `/setup`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      // Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      company: {
        name: InputField?.name ?? '',
        address: InputField?.address ?? '',
        country: InputField?.country,
        state: InputField?.state,
        city: InputField?.city,
        pincode: InputField?.pincode,
        website: InputField?.website,
      },
      configuration: {
        weekStartDay: InputField?.weekStartDay,
        timezone: 'Asia/Kolkata',
        weekendDays: InputField?.weekendDays,
        financialYearStartDate: InputField?.financialYearStartDate,
        financialYearEndDate: InputField?.financialYearEndDate,
      },
      user: {
        firstName: InputField?.firstName,
        lastName: InputField?.lastName,
        email: InputField?.email,
        password: InputField?.password,
        mobile: InputField?.mobile,
        inTime: InputField?.inTime,
        outTime: InputField?.outTime,
      },
    }),
  })
  return await res.json()
}
export async function checkSetup() {
  const {token, tenantId} = setupAxios()
  return await api.get(`/setup/check`, token, tenantId, false).then((res) => res)
}

export const verifyTenantEmailById = async (email: string, k: string) => {
  const {token} = setupAxios()
  const res = await fetch(API_BASE_URL + `/tenants/database`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-Tenant-Id': 'tenants',
    },
    body: JSON.stringify({
      email,
      k,
    }),
  })
  return await res.json()
}
